module.exports = __webpack_public_path__ + "img/szjc10.abdaed59.png";